import { PricingOptionType } from '@iota/iota-management-portal-v4-client';

export const PricingOptionTypes: string[] = [PricingOptionType.FIXED, PricingOptionType.FREE, PricingOptionType.PROPOSAL];

export const PricingOptionTypeDescriptions = new Map([
    ['FIXED', $localize`fix`],
    ['FREE', $localize`selectable`],
    ['PROPOSAL', $localize`selectable with proposals`]
]);
